<template>
  <div>
    <h2
      class="font-[Poppins] font-black text-[clamp(24px,3.5vw,34px)] text-[#191c1e] mb-1.5 tracking-[-0.5px]"
    >
      Receptkort
    </h2>
    <p
      class="font-[Plus_Jakarta_Sans] text-[15px] text-[#6c7a77] leading-[1.65] mb-7 max-w-[580px]"
    >
      Primära displayenheten för recept på Startsidan, Alla recept och
      Receptsidans "Fler recept"-sektion. Innehåller bild, kategorimärke, titel,
      tid, svårighetsnivå och gilla-knapp.
    </p>

    <PreviewBox label="Kortstruktur">
      <!-- Simplified recipe card mockup -->
      <div
        class="w-[220px] rounded-[32px] bg-white overflow-hidden"
        style="box-shadow: 0 4px 16px rgba(0, 0, 0, 0.08)"
      >
        <div
          class="rounded-t-[32px] overflow-hidden bg-gradient-to-br from-teal-100 to-teal-200"
          style="aspect-ratio: 1/1"
        >
          <div class="w-full h-full flex items-center justify-center">
            <span
              class="font-[Poppins] font-bold text-[13px] text-teal-600 opacity-50"
              >Receptbild</span
            >
          </div>
        </div>
        <div class="px-6 pt-3 pb-6 bg-white rounded-b-[32px]">
          <span
            class="font-[Poppins] font-bold text-[10px] text-teal-500 tracking-[1px] uppercase"
            >PASTA</span
          >
          <h3
            class="font-[Poppins] font-bold text-[15px] text-[#191c1e] leading-[21px] mt-1 mb-1.5"
          >
            Carbonara med guanciale
          </h3>
          <hr class="border-t border-[#eceef0] my-2" />
          <div class="flex items-center gap-2">
            <span class="text-[12px] text-[#6c7a77]">⏱ 25 min</span>
            <span class="text-[#d0d5d4] text-[10px]">•</span>
            <span class="flex items-center gap-1">
              <span
                class="w-[6px] h-[6px] rounded-full bg-[#f59e0b] inline-block shrink-0"
              />
              <span class="text-[12px] font-semibold text-[#f59e0b]"
                >Medel</span
              >
            </span>
            <span class="flex-1" />
            <!-- HeartIcon: PhHeart from @phosphor-icons/vue, teal when filled -->
            <PhHeart :size="18" class="text-slate-400" />
          </div>
        </div>
      </div>
    </PreviewBox>

    <CodeBlock :tabs="snippetTabs" />
  </div>
</template>

<script setup>
import { PhHeart } from "@phosphor-icons/vue";
import PreviewBox from "../components/PreviewBox.vue";
import CodeBlock from "../components/CodeBlock.vue";

const htmlCode = `<!-- Skicka ett recipe-objekt med nödvändiga fält -->
<RecipeCard :recipe="recipe" />

<!-- recipe-objektets form (från Rails/Inertia) -->
<!-- {
  id, title, slug, ingress, difficulty,
  total_time, cover_image_url,
  category, category_color, path
} -->`;
const cssCode = `/* Bild */
border-radius: 32px;   /* rounded-[32px] */
aspect-ratio: 1 / 1;
object-fit: cover;
transition: opacity 0.2s, transform 0.3s;

/* Bild:hover */
opacity: 0.9;
transform: scale(1.05);

/* Gilla-knapp (PhHeart) */
/* Gillad  : weight='fill',   color #14b8a6 */
/* Ej gillad: weight='regular', color #94a3b8 */
/* Obs: @click.prevent stoppar navigering */`;

const snippetTabs = [
  { label: "Vue", code: htmlCode },
  { label: "CSS", code: cssCode, lang: "css" },
];
</script>
